// /sources — list page route.

import { createRoute, useNavigate } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { SourcesListPage } from "../sources/SourcesListPage";

export const sourcesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sources",
  component: SourcesIndex,
});

function SourcesIndex() {
  const navigate = useNavigate();
  return (
    <SourcesListPage
      onAdd={() => navigate({ to: "/sources/add" })}
      onView={(id) => navigate({ to: "/sources/$id", params: { id } })}
    />
  );
}
